import React from 'react';
import classes from './AdminDashboard.module.css';

const AdminDashboard = (props) => {
  // component logic
  const temp_backgroundImage = props.backgroundImage;
  let backgroundImage_img = 'https://images.unsplash.com/photo-1470770841072-f978cf4d019e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=247b379684184e3794e14d3400c7d629&auto=format&fit=crop&w=1650&q=80';

  if (temp_backgroundImage.length > 0) {
    backgroundImage_img = props.backgroundImage;
  }
  
  // execute the return function/method
  return (
    <div className={classes.AdminDashboard} style={{backgroundImage: "url(" + backgroundImage_img + ")"}}>
      <div className={classes.adminPanel}>
        <div className={classes.navBar}>
          <div>
            <img className={classes.logo} src="https://mooredigitalsolutions.com/wp-content/uploads/2017/10/logo-03.png" alt=""/>
          </div>
          <div>
            <div>
              <i className="far fa-clock"></i>
            </div>
            <div>
              <i className="fas fa-money-check"></i>
            </div>
            <div>
              <i className="fas fa-bell"></i>
            </div>
            <div>
              {/* two classes */}
              {/* <div className={classes.info + " " + classes.test}>Russell Moore<br/> Admin</div> */}
              <div className={classes.info}>Russell Moore<br/> Admin</div>
              <img className={classes.profilePicture} src="https://ca.slack-edge.com/T28KSDQ0N-UA73V65G8-g457258488a3-48" alt=""/>
            </div>
            <div>
              <i className="fas fa-sign-out-alt"></i>
            </div>
            <div className={classes.navMenu}>
              <i className="fas fa-ellipsis-v"></i>
            </div>
          </div>
        </div>
        <div className={classes.sideNavBar}>
          <div>
            <i className="fas fa-money-check"></i> <span>Link 1</span>
          </div>
          <div>
            <i className="fas fa-address-card"></i> <span>Link 2</span>
          </div>
          <div>
            <i className="fas fa-paste"></i> <span>Link 3</span>
          </div>
          <div>
            <i className="far fa-clock"></i> <span>Link 4</span>
          </div>
          <div>
            <i className="fab fa-slack"></i> <span>Link 5</span>
          </div>
        </div>
        <div className={classes.Panel}>
          <div>
            <div className={classes.cardLabelMain}>
              <h1 className={classes.title}>Title 1</h1>
            </div>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati facere quas odit, accusantium soluta ducimus unde in suscipit, aut voluptatem, architecto corrupti cupiditate veritatis debitis.</p>
          </div>
          <div>
            <div className={classes.cardLabel}>
              <h2 className={classes.title}>Title 2</h2>
            </div>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati facere quas odit, accusantium soluta ducimus unde in suscipit, aut voluptatem, architecto corrupti cupiditate veritatis debitis.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;